import React from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarMnt from '../NewAdminPanel/Common/AdminSidebarMnt';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { useNavigate, useLocation } from "react-router-dom";

const CrmSurveyorCreation = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    
    // Basic user information
    const [userNameValue, setUserNameValue] = useState("");
    const [mobileValue, setMobileValue] = useState("");
    const [emailValue, setEmailValue] = useState("");
    const [designationValue, setDesignationValue] = useState("");
    const [gender, setGender] = useState('');
    const [userCodeLocal, setUserCodeLocal] = useState("");
    
    // State and District related
    const [stateValue, setStateValue] = useState("");
    const [districtValue, setDistrictValue] = useState("");
    
    // Data arrays
    const [statesData, setStatesData] = useState([]);
    const [districtsData, setDistrictsData] = useState([]);
    const [designationData, setDesignationData] = useState([]);

    useEffect(() => {
        fetchDesignation();
        fetchStates();
    }, []);
//alert(sessionStorage.getItem("kvkCode"));
    useEffect(() => {
        if (stateValue && stateValue !== "NA") {
            console.log("State selected:", stateValue, "- Fetching districts...");
            fetchDistricts(stateValue);
        } else {
            console.log("No state selected or state is NA, clearing districts");
            setDistrictsData([]);
            setDistrictValue("");
        }
    }, [stateValue]);

    useEffect(() => {
        // useEffect to set defaultValue in dropdown menu for edit mode
        if (state) {
            console.log("state$$$", state)
            setUserNameValue(state.cropSurveyCode.userName);
            setMobileValue(state.cropSurveyCode.mobile);
            setEmailValue(state.cropSurveyCode.emailId || "");
            setDesignationValue(state.cropSurveyCode.designationCode);
            setUserCodeLocal(state.cropSurveyCode.userCode);
            setGender(state.cropSurveyCode.gender);
            setStateValue(state.cropSurveyCode.stateCode);
            setDistrictValue(state.cropSurveyCode.districtCode);
        }
    }, []);

    const fetchDesignation = async () => {
        try {
            const result = await axios(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/Management/commDesignation`
            );
            setDesignationData(result.data.dataContent);
        } catch (error) {
            console.error("Error fetching designations:", error);
        }
    };

    const fetchStates = async () => {
        try {
            const result = await axios(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/states`
            );
            // Show all states
            const allStates = result.data.dataContent;
            console.log("All states:", allStates);
            setStatesData(allStates);
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };

    const fetchDistricts = async (stateCode) => {
        try {
            console.log("Fetching districts for state code:", stateCode);
            
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: Number(stateCode),
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const response = await fetch(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/district`,
                requestOptions
            );
            
            const result = await response.text();
            const jsonResult = JSON.parse(result);
            console.log("Districts API response:", jsonResult);
            
            if (jsonResult && jsonResult.dataContent) {
                setDistrictsData(jsonResult.dataContent);
                console.log("Districts set successfully:", jsonResult.dataContent.length, "districts");
            } else {
                console.log("No districts data received, setting empty array");
                setDistrictsData([]);
            }
        } catch (error) {
            console.error("Error fetching districts:", error);
            // Don't break the component, just set empty districts
            setDistrictsData([]);
            alert("Error loading districts. Please try again.");
        }
    };

    function ValidateAddUser() {
        console.log("ValidateAddUser function called");
        let valid = false;

        try {
            // State validation
            if(stateValue === "" || stateValue === "NA") {
                alert("Please select a state")
                valid = false;
                return;
            } else {
                valid = true;
            }

            // District validation
            if(districtValue === "" || districtValue === "NA") {
                alert("Please select a district")
                valid = false;
                return;
            } else {
                valid = true;
            }

            // User name validation
            if(userNameValue === "") {
                valid = false;
                alert("Please enter a valid user name")
                return;
            } else {
                valid = true
            }

            // Designation validation
            if(designationValue === "Choose..." || designationValue === "") {
                alert("Please select a designation")
                valid = false;
                return;
            } else {
                valid = true;
            }

            // Mobile validation
            if(document.getElementById("mobilenumber").style.borderColor === "red" || document.getElementById("mobilenumber").value.length === 0) {
                valid = false;
                alert("Please enter a valid 10-digit mobile number")
                return;
            } else {
                valid = true
            }

            if(mobileValue === "") {
                alert("Please enter a valid 10-digit mobile number")
                valid = false;
                return;
            } else {
                valid = true;
            }
             // Email validation
            if(emailValue === "" || emailValue.length < 5 || !validateEmail(emailValue)) {
                alert("Please enter a valid Email ID");
                return;
            }
            // Gender validation
            if(gender === "") {
                valid = false;
                alert("Please select a gender")
                return;
            } else {
                valid = true
            }

            // Email validation (optional but if provided should be valid)
            if(emailValue !== "" && !validateEmail(emailValue)) {
                valid = false;
                alert("Please enter a valid email address")
                return;
            } else {
                valid = true;
            }

            console.log("Validation successful, calling", state ? "UpdateUser" : "AddNewUser");
            if(valid === true) {
                state ? UpdateUser() : AddNewUser();
            }
        } catch (error) {
            console.error("Error in ValidateAddUser:", error);
            alert("An error occurred during validation. Please check console for details.");
        }
    }

    const getCurrentDate = () => {
      const now = new Date();
      return now.toISOString();
  };

    function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    function AddNewUser() {
        console.log("AddNewUser function called");
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            // Current date for timestamp fields
            const currentDate = new Date().toISOString();

            // Create payload for CRM Surveyor user
            const payload = {
                "createdOnByUC": currentDate,
                "createdOnByUC": getCurrentDate(),
                "createdByUC": Number(sessionStorage.getItem("userCodeModel")),
                "modifiedOnByUC": null,
                "modifiedByUC": Number(sessionStorage.getItem("userCodeModel")),
                "userRoleCode": "12",
                "userCode": 0,
                "userName": userNameValue,
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "",
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue,
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode": String(designationValue),
                "stateCode": String(stateValue),
                "districtCode": String(districtValue),
                "subDistrictCode": "",
                "blockCode": "0",
                "villageCode": "",
                "userTypeCode": "2", // kvk user type
                "schemeCode": "16", // CRM scheme
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": currentDate,
                "otp": "",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": 0,
                "fmtcCode": 0,
                "atariCode": 0, // Number(sessionStorage.getItem("userCodeModel")),
                "kvkCode": Number(sessionStorage.getItem("kvkCode")),
            };
            
            console.log("API Payload:", payload);
            var raw = JSON.stringify(payload);

            var requestOptions = {
              method: "POST",
              headers: myHeaders,
              body: raw,
              redirect: "follow",
            };

            console.log("Sending API request to:", `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Users`);
            
            fetch(
              `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Users`,
              requestOptions
            )
              .then((response) => {
                console.log("API Response status:", response.status);
                return response.text();
              })
              .then((result) => {
                console.log("API Response:", result);
                try {
                    const jsonResult = JSON.parse(result);
                    
                    // Handle different response scenarios
                    if (jsonResult.success === true) {
                        alert("CRM Surveyor created successfully!");
                        console.log("CRM Surveyor created successfully, navigating to user list");
                        navigate("/MNT/UsrListMnt");
                    } else {
                        // Handle specific error messages
                        let errorMessage = "Failed to create CRM Surveyor user.";
                        
                        if (jsonResult.message) {
                            if (jsonResult.message.includes("Mobile already exist")) {
                                errorMessage = "A user with this mobile number already exists. Please use a different mobile number.";
                            } else if (jsonResult.message.includes("Email already exist")) {
                                errorMessage = "A user with this email address already exists. Please use a different email address.";
                            } else if (jsonResult.message.includes("User already exist")) {
                                errorMessage = "A user with this information already exists. Please check the details and try again.";
                            } else {
                                errorMessage = jsonResult.message;
                            }
                        }
                        
                        alert(errorMessage);
                    }
                } catch (error) {
                    console.error("Error parsing API response:", error);
                    alert("Error processing server response. Please try again.");
                }
              })
              .catch((error) => {
                console.error("API call error:", error);
                alert("Unable to connect to server. Please check your internet connection and try again.");
              });
        } catch (error) {
            console.error("Error in AddNewUser:", error);
            alert("An error occurred while creating user. Please check console for details.");
        }
    }

    function UpdateUser() {
        console.log("UpdateUser function called");
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            // Current date for timestamp fields
            const currentDate = new Date().toISOString();

            // Create payload for CRM Surveyor user update
            const payload = {
                "createdOnByUC": currentDate,
                "createdByUC": Number(sessionStorage.getItem("userCodeModel")),
                "modifiedOnByUC": currentDate,
                "modifiedByUC": Number(sessionStorage.getItem("userCodeModel")),
                "userRoleCode": "12",
                "userCode": Number(userCodeLocal),
                "userName": userNameValue,
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "",
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue,
                "gender": gender,
                "aadhar": "",
                "departmentCode": "2",
                "designationCode": String(designationValue),
                "stateCode": String(stateValue),
                "districtCode": String(districtValue),
                "subDistrictCode": "",
                "blockCode": "0",
                "villageCode": "",
                "userTypeCode": "2", // CRM State user type
                "schemeCode": "2", // CRM scheme
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": currentDate,
                "otp": "897678",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": 0,
                "fmtcCode": 0,
                "atariCode": 0, //Number(sessionStorage.getItem("userCodeModel")),
                "kvkCode": Number(sessionStorage.getItem("kvkCode")),
            };
            
            console.log("API Payload for update:", payload);
            var raw2 = JSON.stringify(payload);

            var requestOptions = {
              method: "PUT",
              headers: myHeaders,
              body: raw2,
              redirect: "follow",
            };

            console.log("Sending API request to update user:", `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Users`);
            
            fetch(
              `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Users`,
              requestOptions
            )
              .then((response) => {
                console.log("API Response status:", response.status);
                return response.text();
              })
              .then((result) => {
                console.log("API Response:", result);
                try {
                    const jsonResult = JSON.parse(result);
                    
                    // Handle different response scenarios
                    if (jsonResult.success === true) {
                        alert("CRM Surveyor updated successfully!");
                        console.log("CRM Surveyor updated successfully, navigating to user list");
                        navigate("/MNT/UserListMnt");
                    } else {
                        // Handle specific error messages
                        let errorMessage = "Failed to update CRM Surveyor user.";
                        
                        if (jsonResult.message) {
                            if (jsonResult.message.includes("Mobile already exist")) {
                                errorMessage = "A user with this mobile number already exists. Please use a different mobile number.";
                            } else if (jsonResult.message.includes("Email already exist")) {
                                errorMessage = "A user with this email address already exists. Please use a different email address.";
                            } else if (jsonResult.message.includes("User already exist")) {
                                errorMessage = "A user with this information already exists. Please check the details and try again.";
                            } else {
                                errorMessage = jsonResult.message;
                            }
                        }
                        
                        alert(errorMessage);
                    }
                } catch (error) {
                    console.error("Error parsing API response:", error);
                    alert("Error processing server response. Please try again.");
                }
              })
              .catch((error) => {
                console.error("API call error:", error);
                alert("Unable to connect to server. Please check your internet connection and try again.");
              });
        } catch (error) {
            console.error("Error in UpdateUser:", error);
            alert("An error occurred while updating user. Please check console for details.");
        }
    }

    function handleMobileNumber(value) {
        const valueFinal = value.replace(/\D/g, "").replace(/^0/, "").replace(/^1/, "").replace(/^2/, "").replace(/^3/, "").replace(/^4/, "").replace(/^5/, "");
        setMobileValue(valueFinal)
    }

    function validateMobile() {
       if (mobileValue.length === 10) {
          document.getElementById("mobilenumber").style.borderColor = "green";
        } else {
          document.getElementById("mobilenumber").style.borderColor = "red";
        }
    }

    function handleUserName(e) {
      let localText = e.target.value.replace(/[^\w\s]/gi, "")
      console.log("Setting userName to:", localText);
      setUserNameValue(localText)
    }

    function handleEmail(e) {
        setEmailValue(e.target.value);
    }

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarMnt /> 
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>CRM-Surveyor User Creation</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">CRM-Surveyor User Creation</li>
                            <li className="breadcrumb-item">{(sessionStorage.getItem("userNameModel"))}</li>
                        </ol>
                    </nav>
                </div>

                <section className="section dashboard newAdminForms">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        
                                        {/* State Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">State Name</label><label style={{color : "red"}}>*</label>
                                            <select 
                                                className='form-select' 
                                                value={stateValue}
                                                onChange={(e) => setStateValue(e.target.value)}
                                            > 
                                                <option value={"NA"}>Choose...</option>
                                                {statesData.map((item, id) => {
                                                    return (
                                                        <option key={id} value={item.stateCode}>
                                                            {item.stateName}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        
                                        {/* District Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">District Name</label><label style={{color : "red"}}>*</label>
                                            <select 
                                                className='form-select' 
                                                value={districtValue}
                                                onChange={(e) => setDistrictValue(e.target.value)}
                                                disabled={!stateValue || stateValue === "NA"}
                                            >
                                                <option value="NA">Choose...</option>
                                                {districtsData.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.districtCode}>
                                                            {item.districtName}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        
                                        {/* User Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">User Name</label><label style={{color : "red"}}>*</label>
                                            <input 
                                                placeholder='User Name' 
                                                type='text' 
                                                className='form-control' 
                                                onChange={(e) => handleUserName(e)} 
                                                value={userNameValue} 
                                                maxLength={50} 
                                                readOnly={state ? true : false}
                                            />
                                        </div>
                                        
                                        {/* Designation */}
                                        <div className="col-md-4">
                                            <label htmlFor="Designation" className="form-label">
                                              Designation
                                            </label><label style={{color : "red"}}>*</label>
                                            <select
                                              id="Designation"
                                              required
                                              className="form-select"
                                              onChange={(e) => setDesignationValue(e.target.value)}
                                              value={designationValue}
                                            >
                                              <option defaultValue>Choose...</option>
                                              {designationData.map((item, id) => {
                                                return (
                                                  <option key={id} value={item.desigCode}>
                                                    {item.desigName}
                                                  </option>
                                                );
                                              })}
                                            </select>
                                        </div>
                                        
                                        {/* Mobile No */}
                                        <div className="col-md-4">
                                            <label htmlFor="mobileNo" className="form-label">
                                              Mobile No
                                            </label><label style={{color : "red"}}>*</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              id="mobilenumber"
                                              required
                                              placeholder="Mobile No."
                                              onChange={(e) => handleMobileNumber(e.target.value)}
                                              value={mobileValue}
                                              onKeyUp={validateMobile}
                                              maxLength="10"
                                              readOnly={state ? true : false}
                                            />
                                        </div>
                                        {/* Email Id */}
                                        <div className="col-md-4">
                                            <label htmlFor="emailId" className="form-label">
                                              Email Id
                                            </label>
                                            <input
                                              type="email"
                                              className="form-control"
                                              id="emailId"
                                              placeholder="Email Id"
                                              onChange={(e) => handleEmail(e)}
                                              value={emailValue}
                                            />
                                        </div>
                                    </div>
                                        {/* Gender */}
                                        <div className="col-md-6">
                                            <div className="col-md-12">
                                              <label htmlFor="gender" className="form-label">
                                                Gender
                                              </label><label style={{color : "red"}}>*</label>
                                            </div>
                                            <div className="col-md-12">
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  setGender("M");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio1"
                                                  value="male"
                                                  checked={gender === "M"}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio1"
                                                >
                                                  Male
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  setGender("F");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio2"
                                                  value="female"
                                                  checked={gender === "F"}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio2"
                                                >
                                                  Female
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  setGender("T");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio3"
                                                  value="transgender"
                                                  checked={gender === "T"}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio3"
                                                >
                                                  Other
                                                </label>
                                              </div>
                                            </div>
                                          </div>

                                        
                                    
                                    {/* Action Buttons */}
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-center mt-4">
                                        {state ? (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={ValidateAddUser}
                                          >
                                            Update CRM Surveyor
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={() => {
                                              console.log("Create CRM Surveyor button clicked");
                                              ValidateAddUser();
                                            }}
                                          >
                                            Create CRM Surveyor
                                          </button>
                                        )}

                                        <button
                                          className="btn btn-outline-danger"
                                          type="button"
                                          onClick={() => navigate("/MNT/UsrListMnt")}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <AdminFooterNew /> 
        </>
    );
};
 
export default CrmSurveyorCreation; 